/* istanbul ignore file */
import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';
import {
  RECONCILIATION_STATUS_ALIASES,
  RECONCILIATION_STATUS,
} from 'domain/finance/costAccounting/reconcilation/useReconciliationService';

const ReconciliationStatusBadge = ({ value: inputValue, source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });

  const value = inputValue || getValue();

  const getColor = () => {
    switch (value) {
      case RECONCILIATION_STATUS_ALIASES.RECONCILED:
        return 'success';
      case RECONCILIATION_STATUS_ALIASES.POTENTIAL_MATCH:
        return 'primary';
      case RECONCILIATION_STATUS_ALIASES.NOT_RECONCILED:
        return 'error';
      default:
        return 'error';
    }
  };

  return (
    <CustomBadge
      text={RECONCILIATION_STATUS[value]}
      color={getColor()}
      sx={{
        textTransform: 'uppercase',
      }}
      {...props}
    />
  );
};

export default ReconciliationStatusBadge;
